import { FC, useEffect, useState } from "react";
import { ChatState } from "../../../types";
import { Chat, ChatStatus } from "../../../../../types";
import { Column, Row } from "../../../../../components/containers";
import StatusPicture from "../../../../../components/status-picture";
import {
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../../../stores";
import { UserProps, UserStatus } from "../../../../admin-panel/users/types";
import { Text } from "../../../../../components/typography";
import {
  AlignItems,
  JustifyContent,
} from "../../../../../components/containers/types";
import { getTimeStr } from "../../../../../utils";
import { UserProfilePopup } from "../../../../admin-panel/users/user";
import ChatFile from "../chat-file";

const OthersChat: FC<ChatState & { chat: Chat }> = ({ chat, isSidePanel }) => {
  const theme = useThemeStore((s) => s.theme);
  const getUserById = useGeneralStore((s) => s.getUserById);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const users = useGeneralStore((s) => s.users);

  const [user, setUser] = useState<UserProps | null>(
    getUserById(chat.from.$oid)
  );

  useEffect(() => {
    setUser(getUserById(chat.from.$oid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  const showUserProfile = (): void => {
    if (user) setPopupBody(<UserProfilePopup {...user} />);
  };

  return (
    <Row reverse style={{ margin: "1rem 8px" }} className="chat">
      <Row
        reverse
        gap={10}
        style={{ maxWidth: "70%" }}
        alignItems={AlignItems.Start}
      >
        <StatusPicture
          src={user?.pic || ""}
          type={"small"}
          status={user?.status || UserStatus.Offline}
          style={{ marginTop: 20 }}
          onClick={showUserProfile}
        />

        <Column gap={4} style={{ width: "100%" }}>
          <Row
            gap={50}
            style={{ width: "100%" }}
            justifyContent={JustifyContent.Between}
          >
            <Text color={theme.icon}>{user?.role || ""}</Text>

            <Text color={isSidePanel ? theme.textOnBg : theme.textOnOverlay}>
              {user?.fullname || ""}
            </Text>
          </Row>

          {chat.files.map((file) => (
            <ChatFile
              key={!file.local ? file.filename : file.name}
              file={file}
              status={ChatStatus.Sent}
              isSidePanel={isSidePanel}
            />
          ))}

          {chat.content ? (
            <Row
              background={theme.chat.secondary}
              style={{
                width: "calc(100% - 16px)",
                padding: "8px",
                borderRadius: "15px 15px 15px 0",
              }}
            >
              <Text
                textStyles={{
                  whiteSpace: "pre-line",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                color={theme.chat.textOnSecondary}
                size={13}
              >
                {chat.content}
              </Text>
            </Row>
          ) : (
            <></>
          )}

          <Text textStyles={{ width: "100%" }} color={theme.icon}>
            {getTimeStr(chat.date)}
          </Text>
        </Column>
      </Row>
    </Row>
  );
};

export default OthersChat;
